import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavbarIconsCountries from "../generic-nav-bar/NavbarIconsCountries";
import SearchBackCountry from "../generic-search/SearchBackCountry";
import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";
import { useTranslation } from "react-i18next";
import { useTracking } from "react-tracking";
import { cleanSearchingCountrysPaginated, countryCleanSearchText, countryStartDelete, selectCountrys, startLoadingCountrysPaginated, startSearchingCountrysPaginated } from "../../app/actions/catalogCountryActions";
import { startLoadingRegions } from "../../app/actions/catalogRegionActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import TableCountries from "./TableCountries";

const ID_FORM = "admin-country";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCountries = () => {
  debugLogPages(':: ListCountries');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogCountrysS, catalogCountrysP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.catalogCountry);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  useEffect(() => {
    //First Clean list and searchText
    dispatch(cleanSearchingCountrysPaginated());
    dispatch(countryCleanSearchText());
    //Load Data
    dispatch(startLoadingCountrysPaginated(pageInitial, itemsPerPage));
    setSearchText("");

    dispatch(startLoadingRegions());
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditCountries", method: "onEditRow", event: "EditCountries-Clicked" });

    dispatch(selectCountrys(row));
    if (catalogCountrysS?.length > 0) {
      navigate("/admin-country/edit-country", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-country/edit-country");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCountries", method: "onDeleteRow", event: "DeleteCountries-Clicked" });
    dispatch(countryStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {

    if (catalogCountrysS && catalogCountrysS.length > 0) {
      dispatch(startSearchingCountrysPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingCountrysPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogCountrysS && catalogCountrysS.length > 0) {
      dispatch(startSearchingCountrysPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingCountrysPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  return (
    <>
      <NavbarIconsCountries page={"listCountries"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <SearchBackCountry searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      {catalogCountrysS && catalogCountrysS.length > 0 ? (
        <TableCountries data={catalogCountrysS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCountries data={catalogCountrysP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogCountrysS && catalogCountrysS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListCountries;
